import React from 'react'
import { useSelector } from 'react-redux'
import { CSVLink } from 'react-csv'
import { buildCsvString } from '../../utils/csv'
import { Button } from 'antd'
import dayjs from 'dayjs'

const DownloadStatementCsv = () => {
  const { title } = useSelector(state => state.venue.venue)
  const statementOrders = useSelector(
    state => state.orders.filteredStatementOrders,
  )

  const headerOfFile = `Statement Orders of ${title}`
  const statementHeaders = [
    'Supplier Title',
    'PO Number',
    'Date of Order',
    'Order Value (ex. VAT)',
    'VAT Value',
    'Total Due (inc VAT)',
  ]

  const rows = []
  rows.push([headerOfFile])
  rows.push([])
  rows.push(statementHeaders)

  let totalAmount = 0
  let totalVat = 0
  let totalAmountWithVat = 0

  statementOrders?.forEach(item => {
    const amount = item?.totalAmount || 0
    const vat = item?.totalVat || 0
    const total = item?.totalAmountWithVat || 0

    totalAmount += amount
    totalVat += vat
    totalAmountWithVat += total

    rows.push([
      item?._id?.supplierName || '',
      item?._id?.purchaseOrderNumber || '',
      item?.orderedDate ? dayjs(item.orderedDate).format('DD/MM/YY') : '',
      `£${amount.toFixed(2)}`,
      `£${vat.toFixed(2)}`,
      `£${total.toFixed(2)}`,
    ])
  })

  rows.push([])
  rows.push([
    'TOTALS',
    '',
    '',
    `£${totalAmount.toFixed(2)}`,
    `£${totalVat.toFixed(2)}`,
    `£${totalAmountWithVat.toFixed(2)}`,
  ])

  return (
    <Button type='primary' style={{ marginLeft: 16 }}>
      <CSVLink
        data={buildCsvString(rows)}
        filename={`${title}_statement_orders.csv`}
        style={{ color: 'white' }}
      >
        Download CSV
      </CSVLink>
    </Button>
  )
}

export default DownloadStatementCsv
